import authentication from './reactazureb2c';
import decodeJWT from 'jwt-decode';

class Authentication {

  constructor() {
    authentication.initialize();
  }

  getAuthentication() {
    return authentication;
  }

  isLoggedIn() {
    return authentication.isLoggedIn()
  }

  async isLoggedInAndTokenValid() {
    return await authentication.isLoggedInAndTokenValid();
  }

  logout() {
    authentication.signOut();
  }

  getToken() {
    return authentication.getAccessToken();
  }

  setAccessToken(accessToken) {
    return authentication.setAccessToken(accessToken);
  }

  async getTokenAsync() {
    return await authentication.getTokenSilentAsync();
  }

  decodeUserFromToken(token) {
    const decoded = decodeJWT(token);
    return {
      name: decoded.name,
      firstName: decoded.given_name,
      lastName: decoded.family_name,
      emails: decoded.emails,
      city: decoded.city,
      country: decoded.country,
      dqpabnoracn: decoded.extension_DQPABNORACN,
      dqpbusinessname: decoded.extension_DQPBusinessName,
      dqpcertifiedmeterinstallernumber: decoded.extension_DQPCertifiedMeterInstallerNumber,
      dqpphonenumber: decoded.extension_DQPPhoneNumber,
      dqppostaladdress: decoded.extension_DQPPostalAddress,
      dqpqualificationtype: decoded.extension_DQPQualificationType
    };
  }

  currentUser() {
    const decoded = decodeJWT(authentication.getAccessToken());
    return {
      name: decoded.name,
      firstName: decoded.given_name,
      lastName: decoded.family_name,
      emails: decoded.emails,
      city: decoded.city,
      country: decoded.country,
      dqpabnoracn: decoded.extension_DQPABNORACN,
      dqpbusinessname: decoded.extension_DQPBusinessName,
      dqpcertifiedmeterinstallernumber: decoded.extension_DQPCertifiedMeterInstallerNumber,
      dqpphonenumber: decoded.extension_DQPPhoneNumber,
      dqppostaladdress: decoded.extension_DQPPostalAddress,
      dqpqualificationtype: decoded.extension_DQPQualificationType
    };
  }
  login() {
    authentication.login();
  }
  signUp() {
    authentication.signUp();
  }
  profile() {
    authentication.profile();
  }



}

export default Authentication;